import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotificationComponent from '../../components/Notification/NotificationComponent';
import removeNotification from '../../features/actions/removeNotification';

export default function NotificationContainer(props) {
    const notifications = useSelector((state) => state.notifications);
    const dispatch = useDispatch();

    const handleClose = useCallback(
        (notificationId) => {
            const notification = notifications.find((item) => item.id === notificationId);

            if (notification) {
                dispatch(removeNotification(notification));
            }
        },
        [notifications, dispatch],
    );

    return <NotificationComponent notifications={notifications} onClose={handleClose} />;
}
